import toWaterBalanceSeries from 'helper/Meteorology/Agro/waterBalanceSeries';
import { CultureGraph, WBCultureDVGraphResponse } from 'types/Meteorology/Agro/WaterBalanceCulture/DetailedView/getGraph';
import { WBCultureDVOptions, WBCultureDVOptionsResponse } from 'types/Meteorology/Agro/WaterBalanceCulture/DetailedView/getOptions';

export function transformGetOptionsResponse(
  response: WBCultureDVOptionsResponse,
): WBCultureDVOptions {
  const { data } = response;

  return {
    soilTypes: data.tipos_solo,
    cultures: data.culturas,
    variables: data.variaveis
      .filter((v) => v.nome.toLowerCase() !== 'eto')
      .map((v) => ({
        id: v.id, name: v.nome, label: v.label,
      })),
    startDate: data.periodos_de_analise.data_inicial,
    endDate: data.periodos_de_analise.data_final,
    maxInterval: data.periodos_de_analise.intervalo_maximo,
  };
}

export function transformGetGraphResponse(
  response: WBCultureDVGraphResponse,
): CultureGraph {
  return toWaterBalanceSeries(response.data, (variable) => variable.toLowerCase() === 'eto');
}
